import { Td, Th, Thead, Tr, useColorModeValue } from '@chakra-ui/react';

import { CmButton, CmFlex, CmTable, CmTbody } from '@/components/uiParts';

export type Store = {
  id: string;
  name: string;
  accountId: string | null;
  loginId: string | null;
  isConfigured: boolean;
};

type AccountTableProps = {
  stores: Store[];
  onPasswordChange: (
    storeId: string,
    name: string,
    kioskAccountId: string
  ) => void;
  onConfigure: (accountId: string) => void;
  onDelete: (accountId: string) => void;
  onCreateAccount: (storeId: string, name: string) => void;
};

export const AccountTable: React.FC<AccountTableProps> = ({
  stores,
  onPasswordChange,
  onConfigure,
  onDelete,
  onCreateAccount,
}) => {
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const orangeButtonBg = useColorModeValue('#F5A623', 'orange.500');

  const handlePasswordChange = (store: Store) => {
    if (store.accountId) {
      onPasswordChange(store.id, store.name, store.accountId);
    }
  };

  return (
    <CmTable variant="simple">
      <Thead position="sticky" top={0} bg="white" zIndex={1}>
        <Tr borderBottomWidth="1px" borderColor={borderColor}>
          <Th
            width="40%"
            textAlign="left"
            py={4}
            fontSize="md"
            fontWeight="medium"
          >
            店舗名
          </Th>
          <Th
            width="20%"
            textAlign="left"
            py={4}
            fontSize="md"
            fontWeight="medium"
          >
            ログインID
          </Th>
          <Th width="40%" textAlign="right" py={4} />
        </Tr>
      </Thead>
      <CmTbody>
        {stores.map((store) => (
          <Tr key={store.id} borderBottomWidth="1px" borderColor={borderColor}>
            <Td py={4} color="orange.400">
              {store.name}
            </Td>
            <Td py={4}>{store.loginId || '未設定'}</Td>
            <Td textAlign="right" py={4}>
              {store.isConfigured ? (
                <CmFlex justifyContent="flex-end" style={{ gap: '8px' }}>
                  <CmButton
                    size="md"
                    variant="outline"
                    borderRadius="full"
                    borderColor="orange.400"
                    color="orange.400"
                    disabled={!store.accountId}
                    onClick={() => handlePasswordChange(store)}
                    _hover={{ bg: 'orange.50' }}
                  >
                    パスワード変更
                  </CmButton>
                  <CmButton
                    size="md"
                    variant="outline"
                    borderRadius="full"
                    borderColor="gray.300"
                    color="gray.700"
                    bg="gray.100"
                    disabled={!store.accountId}
                    onClick={() =>
                      store.accountId && onConfigure(store.accountId)
                    }
                    _hover={{ bg: 'gray.200' }}
                  >
                    設定
                  </CmButton>
                  <CmButton
                    size="md"
                    variant="outline"
                    borderRadius="full"
                    borderColor="red.400"
                    color="red.400"
                    disabled={!store.accountId}
                    onClick={() => store.accountId && onDelete(store.accountId)}
                    _hover={{ bg: 'red.50' }}
                  >
                    削除
                  </CmButton>
                </CmFlex>
              ) : (
                <CmButton
                  size="md"
                  borderRadius="full"
                  bg={orangeButtonBg}
                  color="white"
                  onClick={() => onCreateAccount(store.id, store.name)}
                  _hover={{ bg: 'orange.600' }}
                >
                  新規作成
                </CmButton>
              )}
            </Td>
          </Tr>
        ))}
      </CmTbody>
    </CmTable>
  );
};
